import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/secure")({
  staticData: { sitemap: false },
  beforeLoad: () => {
    throw redirect({ to: "/settings", replace: true });
  },
});